

// src/pages/About.js - Complete Figma-accurate version
import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/ui/Button';
import { homepageAPI } from '../services/api';
import image1 from '../assets/images/aboutus/image-1.jpg';
import image2 from '../assets/images/aboutus/image-2.jpg';
import image3 from '../assets/images/aboutus/image-3.jpg';
import image4 from '../assets/images/aboutus/image-4.jpg';
import image12 from'../assets/images/homepage/bottom.jpg';
import { Link } from 'react-router-dom';


const About = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fallback stats data
  const fallbackStats = [
    { number: '20+', label: 'years of combined expertise in bakery innovation', icon: '🎯' },
    { number: '500+', label: 'bakeries served across India with custom solutions', icon: '🏆' },
    { number: '23%', label: 'average reduction in production costs for clients', icon: '💰' },
    { number: '90%', label: 'client retention rate—built on trust and results', icon: '⭐' }
  ];

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await homepageAPI.getStats();
        if (data && data.length > 0) {
          setStats(data.map((stat, idx) => ({
            ...stat,
            icon: fallbackStats[idx]?.icon || '📊'
          })));
        } else {
          setStats(fallbackStats);
        }
        setLoading(false);
      } catch (err) {
        setStats(fallbackStats);
        setLoading(false);
      }
    };

    fetchStats();
  }, []);
  return (
    <div className="min-h-screen bg-white lg:bg-cream">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="flex flex-col items-center gap-12 lg:flex-row">
            <div className="flex-1">
              <img 
                src={image1} 
                alt="Transform Your Bakery"
                className="w-full h-[500px] object-cover rounded-3xl shadow-xl"
              />
            </div>
            <div className="flex-1 max-w-xl">
              <div className="mb-3 text-xs font-semibold tracking-wider uppercase text-primary">
                About Enessa
              </div>
              <h1 className="mb-6 font-serif text-5xl font-bold leading-tight text-text-primary">
                Transform Your Bakery Operations—Today!
              </h1>
              <p className="mb-6 text-lg leading-relaxed text-text-primary">
                ENESSA FOODS is a trusted name in the baking industry, offering a wide range of high-quality ingredients designed to enhance the performance and quality of your baked goods. With years of experience and a deep understanding of the needs of professional bakers, we are committed to providing products that ensure consistency, efficiency, and excellence in every bake.
              </p>
              <p className="mb-6 text-lg leading-relaxed text-text-primary">
                Our young company offers both small and large food producers the bundled know-how of experienced engineers from various branches. Key areas of focus are innovative ultrasonic systems and conventional cutting technologies, which can be tailored to meet the individual production requirements of each customer.
              </p>
              <p className="mb-6 text-lg leading-relaxed text-text-primary">
                At Enessa Foods, we believe in the power of collaboration and innovation. Our team of experts is constantly researching and developing new solutions to meet the evolving demands of the baking industry. We are dedicated to sustainability and strive to minimize our environmental impact through eco-friendly practices and responsible sourcing.
              </p>
              <p className="mb-6 text-lg leading-relaxed text-text-primary">
                A solid history and Global experience in the food industry ensure that Enessa Foods clients have access to unsurpassed expertise and industry insight. However, this established credibility has been matched by an equally strong commitment to innovation and flexibility to adapt to the changing needs of the industry.
              </p>
              <p className="mb-6 text-lg leading-relaxed text-text-primary">
                Enessa Foods remains at the cutting edge of technological advancements, fresh ideas and innovative products to ensure customers have access to the latest and most advanced ingredient solutions.
              </p>
              <p className="mb-8 text-lg leading-relaxed text-text-primary">
                Enessa Foods impressive range of turnkey, custom ingredient solutions is enhanced by a firm commitment to excellence in food hygiene and safety systems, as well as unrivalled technical support.
              </p>
              <div className="flex gap-4">
                <Button variant="primary"><a href="/products">Get Started</a></Button>
                <Button variant="secondary"><a href="/services">Learn More</a></Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* statistics Section */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="mb-4 font-serif text-4xl font-bold text-text-primary">
              Numbers That Speak<br/>for Themselves
            </h2>
            <p className="text-brown-light">Backed by 24/7 technical support across all regions.
From product launches to partner growth—Enessa delivers.</p>
          </div>
          
          <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
            {loading ? (
              Array.from({ length: 4 }).map((_, idx) => (
                <div key={idx} className="p-8 text-center bg-white rounded-3xl shadow-soft animate-pulse">
                  <div className="h-12 mb-3 bg-gray-200 rounded"></div>
                  <div className="h-12 mb-3 bg-gray-200 rounded"></div>
                  <div className="h-8 bg-gray-200 rounded"></div>
                </div>
              ))
            ) : (
              stats.map((stat, idx) => (
                <div key={idx} className="p-8 text-center bg-white rounded-3xl shadow-soft">
                  <div className="mb-3 text-4xl">{stat.icon}</div>
                  <div className="mb-3 text-5xl font-bold text-primary">{stat.number}</div>
                  <p className="text-sm leading-relaxed text-text-primary">{stat.label}</p>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* Service Sections */}
      {[
        {
          title: 'OUR MISSION',
          subtitle: 'Empowering Bakers',
          description: 'AT ENESSA FOODS, our mission is to empower bakers with high-quality, innovative ingredients that enhance the performance and quality of their baked goods. We are dedicated to supporting the baking industry by providing cost-effective solutions that ensure consistency, efficiency, and excellence in every bake. Our commitment to sustainability and customer satisfaction drives us to continuously improve and innovate, ensuring that our products meet the evolving needs of our customers and to support bakers in creating delicious and innovative products that delight their customers. We achieve this by sourcing the finest ingredients and employing rigorous quality control measures to ensure that every product meets our high standards. Whether you are a small artisan bakery or a large commercial operation, Enessa Foods has the expertise and resources to help you succeed.',
          features: [
            'Sourcing the finest ingredients',
            'Rigorous quality control measures',
            'Support for small artisan bakeries and large commercial operations',
            'Expertise and resources to help you succeed'
          ],
          image: image2,
          reverse: false
        },
        {
          title: 'OUR VISION',
          subtitle: 'Leading the Future',
          description: 'OUR VISION is to serve as dynamic and innovative organization & be the leading provider of premium baking ingredients, recognized for our unwavering commitment to quality, sustainability, and customer support while advancing to be reliable contributor in food productions and distributions in global markets. We aspire to create a positive impact on the baking industry by fostering innovation, promoting eco-friendly practices, and building lasting relationships with our customers. At Enessa Foods, we envision a future where our ingredients help bakers around the world create delicious, sustainable, and high-quality baked goods that delight their customers.',
          features: [
            'Dynamic and innovative organization',
            'Leading provider of premium baking ingredients',
            'Commitment to quality, sustainability, and customer support',
            'Reliable contributor in global food production and distribution'
          ],
          image: image3,
          reverse: true
        }
      ].map((service, idx) => (
        <section key={idx} className={`py-16 ${idx % 2 === 0 ? ' bg-white lg:bg-cream' : 'bg-white lg:bg-cream'}`}>
          <div className="px-6 mx-auto max-w-7xl lg:px-8">
            <div className={`flex flex-col ${service.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12`}>
              <div className="flex-1">
                <div className="mb-2 text-xs font-semibold tracking-wider uppercase text-text-primary">
                  {service.subtitle}
                </div>
                <h3 className="mb-5 font-serif text-4xl font-bold text-text-primary">{service.title}</h3>
                <p className="mb-6 leading-relaxed text-text-primary">{service.description}</p>
                
                <ul className="mb-6 space-y-3">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <svg className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                      </svg>
                      <span className=" text-primary">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <div className="flex gap-4">
                  <Button variant="primary"><a href="/products">Get Started</a></Button>
                  <Button variant="secondary"><a href="/services">Learn More</a></Button>
                </div>
              </div>
              <div className="flex-1">
                <img src={service.image} alt={service.title} className="object-cover w-full shadow-lg h-96 rounded-3xl" />
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* More Services Grid */}
      <section className="py-16 bg-white lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="mb-4 font-serif text-4xl font-bold text-text-primary">
              WHY CHOOSE ENESSA FOODS?
            </h2>
            <p className="max-w-3xl mx-auto text-text-primary">
              OUR PRODUCTS HELP TO ACHIEVE:
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[
              {
                icon: '🔬',
                title: 'SUPERIOR QUALITY',
                description: 'We use the finest ingredients to enhance Quality, Consistency and characteristics of Product.'
              },
              {
                icon: '🏪',
                title: 'PROCESSABILITY',
                description: 'Enhancing efficiency and ensuring smooth operations, helps to minimize wastage and reduce losses.'
              },
              {
                icon: '💰',
                title: 'COST-EFFECTIVE',
                description: 'Bring down raw material COST with competitive pricing without compromising on quality.'
              },
              {
                icon: '🌱',
                title: 'SUSTAINABILITY',
                description: 'Committed to eco-friendly practices and reducing our environmental footprint.'
              },
              {
                icon: '📞',
                title: 'CUSTOMER SUPPORT',
                description: 'Dedicated to providing excellent service and support.'
              }
            ].map((item, idx) => (
              <div key={idx} className="p-8 bg-white lg:bg-cream rounded-3xl">
                <div className="mb-4 text-5xl">{item.icon}</div>
                <div className="mb-2 text-xs font-semibold uppercase text-primary">{item.subtitle}</div>
                <h4 className="mb-3 text-xl font-bold text-text-primary">{item.title}</h4>
                <p className="text-sm leading-relaxed text-text-primary">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Section */}
      <section className="py-20" style={{background: 'bg-white lg:bg-cream'}}>
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="mb-4 font-serif text-4xl font-bold text-text-primary">
              BECOME A PARTNER AT NO RISK
            </h2>
            <p className="max-w-3xl mx-auto text-lg text-text-primary">
              We rely on our experience and expertise to master the various challenges we face every day. The trust of our customers is based on the quality of our performance.
            </p>
            <p className="max-w-3xl mx-auto mt-4 text-lg text-text-primary">
              ENESSA FOODS works with brand-name partners around the India as well as innovative pioneers in the food industry sector. We have a partner network that guarantees customers the best possible service with maximum quality.
            </p>
          </div>

          <div className="mb-8 text-center">
            <h3 className="mb-6 text-2xl font-bold text-text-primary">YOUR BENEFITS AS A PARTNER</h3>
          </div>

          <div className="grid gap-8 mb-12 md:grid-cols-2">
            {[
              {
                icon: '🎯',
                title: 'Integration of Partner Products',
                description: 'Integration of partner products and technologies to satisfy customer requirements and strengthen competitiveness'
              },
              {
                icon: '🔄',
                title: 'Tap New Market Segments',
                description: 'Tap new market segments through first-class combinations of new and proven solutions'
              },
              {
                icon: '💡',
                title: 'Efficient Marketing & Sales',
                description: 'More efficient use of marketing and sales channels with a strong partner focused on the sector.'
              },
              {
                icon: '💰',
                title: 'Cost Savings',
                description: 'Cost savings through optimized solutions and shared resources within our partner network.'
              }
            ].map((item, idx) => (
              <div key={idx} className="p-8 text-text-primary bg-white/10 backdrop-blur-sm rounded-3xl">
                <div className="mb-4 text-5xl">{item.icon}</div>
                <h4 className="mb-3 text-2xl font-bold">{item.title}</h4>
                <p className="leading-relaxed text-text-primary">{item.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a href="/contact" className="inline-block px-10 py-4 text-lg font-medium transition-all bg-white rounded-full shadow-xl text-primary hover:bg-white/90">
              Let's Partner Up
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA */}
     {/* Final CTA with Chef */}
      <section className="py-24 bg-white lg:py-40 lg:bg-cream">
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="bg-white rounded-[40px] p-12 lg:p-24 shadow-soft flex flex-col lg:flex-row-reverse items-center gap-16">
            <div className="flex-1">
              <img src={image12} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="mb-8 leading-tight font-heading text-heading-lg text-text-primary">
                Let's Rise Together—Start Today!
              </h2>
              <p className="mb-10 leading-normal font-body text-body-lg text-text-primary">
                Ready to elevate your bakery business? Partner with Enessa Foods for innovative solutions, reliable performance and zero-risk growth.
              </p>
              <div className="flex flex-wrap justify-center gap-6 lg:justify-start">
                <Link to="/contact"><Button variant="primary" size="large">Contact Us</Button></Link>
                <Link to="/contact#inquiry-section"><Button variant="secondary" size="large">Enquiry Form</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};


export default About;


